import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import { useNavigate, useLocation } from 'react-router-dom';
import { saveAs } from "file-saver";
import "../../../styles/Auth/product.css";
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
    Tooltip
} from '@mui/material';
import { Box, Modal, Button, Menu, MenuItem } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import ViewProductPopup from './viewProductPopup.jsx';
import { getData, uploadFile, postData, deleteData, putData } from '../../../webService/webservice.js';
import TVFMLoader from "../Loader/loader.jsx";
import { useStore } from "../../../Context/context.jsx";
import StockImagePicker from "../../../components/Common/ImagePicker/StockImagePicker.jsx";
import AddStoreForm from "../store/AddStoreForm.jsx";
import StoreMultiSelect from "../../Challange/storeMultiSelect.jsx";
import StoreSingleAllStoresSelect, { ALL_STORE_OPTION } from "../../Challange/StoreSingleAllStoresSelect.jsx";
import CategorySelect from "../../Challange/CategorySelect.jsx";
import SubCategorySelect from "../../Challange/SubCategorySelect.jsx";
import AddCategoryForm from "../Category/AddCategoryForm.jsx";
import AddSubCategoryForm from "../SubCategory/AddSubCategoryForm.jsx";
import Footer from "../Footer/Footer-page.jsx";
const ProductPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId =
        adminStoreIds[0] ||
        "";
    const isAddProduct = location.pathname === '/products/add';
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'S.No',
        'Image',
        'Name',
        'Location',
        'GST (%)',
        'Price',
        'Action',
    ];
    const fileInputRef = useRef(null);
    const [actionAnchorEl, setActionAnchorEl] = useState(null);
    const isActionMenuOpen = Boolean(actionAnchorEl);
    const handleActionClick = (event) => {
        setActionAnchorEl(event.currentTarget);
    };
    const handleActionClose = () => {
        setActionAnchorEl(null);
    };
    const [previewUrl, setPreviewUrl] = useState(null);
    const [productImage, setProductImage] = useState(null);
    const [categories, setCategories] = useState([]);
    const [subcategories, setsubcategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [viewProductData, setViewProductData] = useState(null);
    const [openViewPopup, setOpenViewPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [open, setOpen] = useState(false);
    const sessionToken = localStorage.getItem("Token");
    const [isAddStore, setIsAddStore] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [productsToDelete, setProductsToDelete] = useState(null);
    const [limit, setLimit] = useState(5);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editProductId, setEditProductId] = useState(null);
    const [isAddCategory, setIsAddCategory] = useState(false);
    const [isAddSubCategory, setIsAddSubCategory] = useState(false);
    const [categoryRefreshKey, setCategoryRefreshKey] = useState(0);
    const [subCategoryRefreshKey, setSubCategoryRefreshKey] = useState(0);
    const { selectedStoreId, setSelectedStoreId } = useStore();
    const [store, setStore] = useState(() => ({
        value: initialStoreId,
        label: initialStoreId === "" ? "All Stores" : "Loading..."
    }));
    const [fileName, setFileName] = useState("");
    const [errors, setErrors] = useState({});
    const [sortField, setSortField] = useState("createdAt");
    const [sortOrder, setSortOrder] = useState(-1);
    const [isGSTVerified, setIsGSTVerified] = useState(false);
    const [uploadMethod, setUploadMethod] = useState("Normal");
    const [selectedStockImage, setSelectedStockImage] = useState(null);
    const [showStockPicker, setShowStockPicker] = useState(false);

    const sort = [[sortField, sortOrder]];

    const handleSort = (field) => {
        const newOrder =
            sortField === field ? (sortOrder === 1 ? -1 : 1) : -1;

        setSortField(field);
        setSortOrder(newOrder);
    };

    const [formData, setFormData] = useState({
        title: '',
        productImageObject: '',
        categoryId: '',
        categoryName: '',
        subCategoryId: '',
        subCategoryName: '',
        storeId: initialStoreId,
        upc: '',
        unitType: '',
        unitName: '',
        unitValue: '',
        ideal_for: '',
        purchasePrice: '',
        sellingPrice: '',
        gstPercentage: '',
        gstAmount: '',
        variantName: '',
        hsnCode: '',
        storeName: "", // Initialize storeName
    });

    useEffect(() => {
        const fetchStoreDetails = async () => {
            try {
                const sid = Array.isArray(formData.storeId)
                    ? formData.storeId[0]
                    : formData.storeId;

                if (!sid) return;

                const res = await getData(
                    `stores/store/${sid}`,
                    {},
                    sessionToken
                );

                if (res?.data) {

                    setFormData(prev => ({
                        ...prev,
                        storeName:
                            prev.storeName ||
                            res.data.storeName
                    }));

                    const gstValid =
                        res.data?.gstData?.valid === true;

                    console.log("GST VALID :", gstValid);

                    setIsGSTVerified(gstValid);
                }
            } catch (err) {
                console.error(
                    "Failed to fetch store details",
                    err
                );
            }
        };

        fetchStoreDetails();
    }, [formData.storeId]);

    useEffect(() => {
        if (!isGSTVerified) {
            setFormData(prev => ({
                ...prev,
                gstPercentage: 0,
                gstAmount: "0.00"
            }));
        }
    }, [isGSTVerified]);


    const loadCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            const sid = Array.isArray(formData.storeId)
                ? formData.storeId[0]
                : formData.storeId;

            // If global store is "all" or invalid, try to use store(s) from the form
            if (!sid || sid === "all") {
                if (isPopupMode && formData.storeId) {
                    sid = formData.storeId;
                } else if (isAddProduct && formData.storeId?.length > 0) {
                    sid = formData.storeId[0];
                }
            }

            const params = {
                page,
                limit: 100000,
                search: inputValue,
            };
            if (sid && sid.length === 24) {
                params.storeId = sid;
            }
            const token = localStorage.getItem("Token");
            const res = await getData('categories/categories', params, token);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(cat => ({ value: cat._id, label: cat.categoryName }));
            return { options, hasMore: results.length === 1000, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const calculateGSTAmount = (price, gst) => {
        const base = Number(price || 0);
        const gstPercent = Number(gst || 0);
        return ((base * gstPercent) / 100).toFixed(2);
    };

    const loadSubCategories = async (inputValue, loadedOptions, { page }) => {
        try {
            if (!formData.categoryId) return { options: [], hasMore: false };
            const sid = Array.isArray(formData.storeId)
                ? formData.storeId[0]
                : formData.storeId;

            // If global store is "all" or invalid, try to use store(s) from the form
            if (!sid || sid === "all") {
                if (isPopupMode && formData.storeId) {
                    sid = formData.storeId;
                } else if (isAddProduct && formData.storeId?.length > 0) {
                    sid = formData.storeId[0];
                }
            }

            const params = {
                page,
                limit: 100000,
                search: inputValue,
                categoryId: formData.categoryId,
            };
            if (sid && sid.length === 24) {
                params.storeId = sid;
            }
            const token = localStorage.getItem("Token");
            const res = await getData('subcategories/subcategories', params, token);
            const results = res?.data?.results?.[0]?.paginatedResults || [];
            const options = results.map(sub => ({ value: sub._id, label: sub.subCategoryName || sub.name }));
            return { options, hasMore: results.length === 1000, additional: { page: page + 1 } };
        } catch (err) {
            return { options: [], hasMore: false };
        }
    };

    const EMPTY_ARRAY = [];

    const loadStores = async (inputValue, loadedOptions, { page }) => {
        try {
            const res = await getData(
                "stores/stores",
                { page, limit: 1000, search: inputValue },
                sessionToken
            );

            const results = res?.data?.results || EMPTY_ARRAY;

            const options = results.map(store => ({
                value: store._id,
                label: store.storeName
            }));

            return {
                options,
                hasMore: results.length === 1000,
                additional: { page: page + 1 }
            };

        } catch (err) {
            console.error("Store Fetch Failed", err);
            return { options: [], hasMore: false };
        }
    };

    const [showLoader, setShowLoader] = useState(false);
    const [loaderText, setLoaderText] = useState('');

    useEffect(() => {
        // stores = array of store objects you already load for dropdown
        if (stores && stores.length === 1) {
            const onlyStore = stores[0]._id;
            setSelectedStoreId(onlyStore);
            console.log("✔ Auto-selected store because only one store exists:", onlyStore);
        }
    }, [stores]);


    const handleRemoveImage = () => {
        setProductImage(null);
        setSelectedStockImage(null);
        setPreviewUrl(null);
        setFileName("");
    };

    const handleStockSelect = (imageObject) => {
        if (!imageObject) return;
        setSelectedStockImage(imageObject);
        const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
        const uri = imageObject.uri || imageObject.fileObject?.uri || "";
        if (uri) {
            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
        }
        setShowStockPicker(false);
        setErrors(prev => ({ ...prev, productImage: null }));
    };

    const handleBulkUploadClick = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            // Priority: Use the store selected in the dropdown for Admins, or global context for others.
            const sid = (["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role))
                ? store?.value
                : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

            const storeIdToUse =
                sid ||
                (stores?.length === 1 ? stores[0]._id : null);

            if (!storeIdToUse) {
                alert("Please select a store before uploading");
                return;
            }

            const formData = new FormData();
            formData.append("file", file);
            formData.append("storeIds", storeIdToUse);

            console.log("✔ Bulk Upload Using Store:", storeIdToUse);

            const response = await postData(
                `/products/bulkupload/${userId}`,
                formData,
                token,
                true
            );

            if (response && response.success === false) {
                alert(response.message || "Error uploading file!");
                // Clear the input value so user can upload the same file again if needed
                if (e.target) e.target.value = "";
                return;
            } else if (response && response.status && response.status !== 200 && response.status !== 201) {
                alert(response.message || "Error uploading file!");
                if (e.target) e.target.value = "";
                return;
            }

            alert(response.message || "Bulk Upload Successful!");
            navigate("/products");
            triggerRefresh();

        } catch (error) {
            console.error("Bulk Upload Failed:", error);
            alert(error?.message || "Error uploading file!");
            if (e.target) e.target.value = "";
        }
    };

    const handleAddProduct = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, productImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let productImageObject = null;
            const isStockUpload = uploadMethod === "Stock";

            if (!isStockUpload) {
                if (productImage && userId) {
                    const uploadResult = await uploadFile(`files/upload/${userId}`, productImage);
                    if (uploadResult?.status === 200 || uploadResult?.success) {
                        productImageObject = uploadResult.data;
                    } else {
                        toast.error(uploadResult?.message || "Image upload failed");
                        setShowLoader(false);
                        return;
                    }
                }
            } else {
                productImageObject = selectedStockImage;
            }



            const productData = {
                storeId: formData.storeId,
                title: formData.title,
                categoryId: formData.categoryId,
                subCategoryId: formData.subCategoryId,
                upc: formData.upc,
                unitType: formData.unitType,
                unitName: formData.unitName,
                unitValue: formData.unitValue,
                ideal_for: formData.ideal_for,
                hsnCode: formData.hsnCode,
                purchasePrice: formData.purchasePrice,
                gstAmount: formData.gstAmount,
                sellingPrice: formData.sellingPrice,
                gstPercentage: formData.gstPercentage,
                variantName: formData.variantName,
                productImageObject,
                imageSource: isStockUpload ? "Stock" : "Upload"
            };

            const response = await postData("products/", productData, token);

            toast.success(response.message || "Product added successfully");

            setFormData({
                title: "",
                categoryId: "",
                categoryName: "",
                subCategoryId: "",
                subCategoryName: "",
                upc: "",
                unitType: "",
                unitName: "",
                unitValue: "",
                ideal_for: "",
                sellingPrice: "",
                purchasePrice: "",
                gstPercentage: "",
                variantName: "",
                gstAmount: "",
                hsnCode: "",
            });

            setProductImage(null);
            setSelectedStockImage(null);
            setPreviewUrl(null);
            setUploadMethod("Normal");
            navigate("/products");
            triggerRefresh();

        } catch (error) {
            console.error(error);
            toast.error("Add Product Failed");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };


    useEffect(() => {
        fetchProducts(currentPage, limit, searchQuery, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId, sortField, sortOrder, store]);

    const fetchProducts = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit: limit === 'all' ? 999999 : limit,
            title: searchQuery?.trim() || "",
            sort: JSON.stringify([[sortField, sortOrder]])
        }
        const sid = ["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) ? store?.value : Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('products/products', params, sessionToken);
            console.log("response", response);
            if (response?.status !== 200) {
                toast.error(response?.message || "Failed to fetch Products");
                return;
            }
            const resultsWrapper = response?.data?.[0];
            const productsList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setProducts(productsList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            console.error(error);
            toast.error(error.datamessage || "Failed to fetch Products");
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteProduct = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('Token');
            const response = await deleteData(`products/product/${productsToDelete}`, token);
            toast.success(response.message || "Product deleted successfully");
            setProductsToDelete(null);
            fetchProducts(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Product");
        }
    }

    const handleUpdateProduct = async (e) => {
        e.preventDefault();

        const validationErrors = validateFields(formData, uploadMethod, productImage, selectedStockImage);
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        setErrors({});
        setShowLoader(true);

        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");

            let updatedImageObject = uploadMethod === "Stock" ? selectedStockImage : (productImage ? null : formData.productImageObject);

            if (uploadMethod === "Normal" && productImage && userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, productImage);
                if (uploadResult?.status === 200 || uploadResult?.success) {
                    updatedImageObject = uploadResult.data;
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    setShowLoader(false);
                    return;
                }
            } else if (uploadMethod === "Stock") {
                updatedImageObject = selectedStockImage;
            }

            const updatedProductData = {
                title: formData.title,
                categoryId: formData.categoryId,
                subCategoryId: formData.subCategoryId,
                storeId: formData.storeId,
                upc: formData.upc,
                unitType: formData.unitType,
                unitName: formData.unitName,
                ideal_for: formData.ideal_for,
                purchasePrice: formData.purchasePrice,
                sellingPrice: formData.sellingPrice,
                productImageObject: updatedImageObject,
                hsnCode: formData.hsnCode,
                gstPercentage: formData.gstPercentage,
                gstAmount: formData.gstAmount,
                variantName: formData.variantName,
                imageSource: uploadMethod === "Stock" ? "Stock" : "Upload"
            };

            console.log("Updating Product with data:", updatedProductData);

            const response = await putData(
                `products/product/${editProductId}`,
                updatedProductData,
                token
            );

            toast.success(response.message || "Product updated successfully");

            // ✅ Reset form & UI
            setFormData({
                title: '',
                productImageObject: '',
                categoryId: '',
                categoryName: '',
                subCategoryId: '',
                subCategoryName: '',
                storeId: '',
                upc: '',
                unitType: '',
                unitName: '',
                unitValue: '',
                ideal_for: '',
                purchasePrice: '',
                sellingPrice: '',
                gstPercentage: '',
                gstAmount: '',
                variantName: '',
                hsnCode: '',
            });

            setProductImage(null);
            setSelectedStockImage(null);
            setPreviewUrl(null);
            setUploadMethod("Normal");
            setIsPopupMode(false);
            setIsEditMode(false);
            fetchProducts(currentPage, limit);
            triggerRefresh();

        } catch (error) {
            console.error("Update Product Error:", error);
            toast.error("Error updating product.");
        } finally {
            setTimeout(() => {
                setShowLoader(false);
            }, 1000);
        }
    };


    const handleViewProduct = async (productId) => {
        try {
            setLoading(true);

            // Assuming sessionToken is from localStorage
            const sessionToken = localStorage.getItem("Token");

            // Fetch data using your getData function
            const response = await getData(`products/product/${productId}`, sessionToken);

            // Check if response is already JSON
            const data = response?.data || response;

            // Set the view data
            setViewProductData(data);
            setOpenViewPopup(true);
        } catch (error) {
            console.error("Error fetching Product:", error);
            toast.error(error.message || "Failed to fetch Product data");
        } finally {
            setLoading(false);
        }
    };

    const handleOpen = (categoryId) => {
        setProductsToDelete(categoryId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setProductsToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const unitOptions = {
        weight: ['Gram', 'Kilogram', 'Milligram'],
        volume: ['Litre', 'Millilitre'],
        unit: ['Piece', 'Packet', 'Bottle', 'Box'],
    };



    const handlePageChange = (direction) => {
        setCurrentPage((prev) => {
            if (direction === "next") return Math.min(prev + 1, totalPages);
            if (direction === "prev") return Math.max(prev - 1, 1);
            if (direction === "first") return 1;
            if (direction === "last") return totalPages;
            return prev;
        });
    };

    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };


    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };

    useEffect(() => {
        const storedFileName = localStorage.getItem("fileName");
        if (storedFileName) {
            setFileName(storedFileName);
        }
    }, []);

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId =
                selectedStoreId ||
                adminStoreIds[0] ||
                "";

            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        // 🔥 IMPORTANT: run once on mount
        handleStoreChange();

        window.addEventListener("storeChanged", handleStoreChange);

        return () => {
            window.removeEventListener("storeChanged", handleStoreChange);
        };
    }, []);


    const sampleServiceData = [
        {
            title: "Shaving Cream",
            purchasePrice: "300",
            unitType: "unit",
            unitName: "Piece"
        }]

    const handleExportExcel = async () => {
        const token = localStorage.getItem("Token");
        const sid = (role === "SuperAdmin" || role === "SelfAdmin")
            ? store?.value
            : (Array.isArray(selectedStoreId) ? selectedStoreId[0] : selectedStoreId);

        const storeIdToUse =
            sid ||
            (stores?.length === 1 ? stores[0]._id : null);

        if (!storeIdToUse) {
            alert("Please select a store before downloading the sample template");
            return;
        }

        try {
            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
            const response = await fetch(`${baseUrl}/products/sample-template/${storeIdToUse}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error("Failed to download template");
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Products.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Failed to generate sample template:", error);
            alert("Failed to generate sample template. Please try again.");
        }
    };

    const handleExportExcelProductData = () => {

        if (!products || products.length === 0) {
            return toast.error("No data available to export");
        }

        // Map data to show names instead of IDs
        const exportData = products.map(product => ({
            "Product Name": product.title,
            "Store Name": product.store?.[0]?.storeName || "",
            "Category Name": product.categoryDetails?.categoryName || "",
            "Sub Category Name": product.subCategoryDetails?.subCategoryName || "",
            "UPC": product.upc,
            "Unit Type": product.unitType,
            "Unit Name": product.unitName,
            "Unit Value": product.unitValue,
            "Ideal For": product.ideal_for,
            "Selling Price": product.sellingPrice,
            "Purchase Price": product.purchasePrice,
            "GST Percentage": product.gstPercentage,
            "GST Amount": product.gstAmount,
            "HSN Code": product.hsnCode,
            "Variant Name": product.variantName,
        }));

        // Convert to worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

        // Convert to Excel buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        // Create Blob
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(data, `products-${Date.now()}.xlsx`);
    };


    const validateFields = (data, method, img, stockImg) => {
        let newErrors = {};
        if (!data.storeId) newErrors.storeId = "Store is required";
        if (!data.title?.trim()) newErrors.title = "Product Name is required";
        if (!data.unitType) newErrors.unitType = "UnitType is required";
        if (!data.unitName) newErrors.unitName = "UnitName is required";
        if (!data.unitValue) newErrors.unitValue = "UnitValue is required";
        if (!data.categoryId) newErrors.categoryId = "Category is required";
        if (!data.subCategoryId) newErrors.subCategoryId = "Sub Category is required";
        if (!data.ideal_for) newErrors.ideal_for = "Ideal For is required";
        if (isGSTVerified && data.gstPercentage === "") {
            newErrors.gstPercentage = "GST Percentage is required";
        }



        if (method === "Normal" && img) {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
            const allowedExtensions = ["jpg", "jpeg", "png"];
            const fileExtension = img.name.split('.').pop().toLowerCase();
            const isValidType = allowedTypes.includes(img.type) || allowedExtensions.includes(fileExtension);
            if (!isValidType) {
                newErrors.productImage = "Only JPEG, JPG, and PNG images are allowed.";
            } else if (img.size > 1024 * 1024) {
                newErrors.productImage = "Image size exceeds 1MB. Please select an image smaller than 1MB.";
            }
        }

        return newErrors;
    }

    useEffect(() => {
        if (isAddProduct && initialStoreId) {
            setFormData(prev => ({
                ...prev,
                storeId: initialStoreId
            }));
        }
    }, [isAddProduct, initialStoreId]);


    return (
        <div className="product-layout">
            <div className="product-content">
                {
                    showLoader && (
                        <div className="scissor-overlay">
                            <div className="scissor-loader">
                                <TVFMLoader />
                            </div>
                        </div>
                    )
                }
                <main className="product-main">
                    {isAddProduct ? (
                        <div className="add-Product-form">
                            <Typography variant="h6" gutterBottom>Add Product</Typography>
                            <form className="Product-form">
                                <div className="Product-form-row">
                                    <div className="Product-form-group">
                                        <label htmlFor="title" className="input-label">
                                            Product Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Product name"
                                            required
                                            className="Product-input"
                                            value={formData.title}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, title: e.target.value }))
                                            }
                                        />
                                        {errors.title && <p className="field-error">{errors.title}</p>}
                                    </div>

                                    <div className="Product-form-group">
                                        <label className="input-label">Store Name</label>

                                        <StoreMultiSelect
                                            value={
                                                formData.storeId
                                                    ? [{
                                                        value: formData.storeId,
                                                        label: formData.storeName
                                                    }]
                                                    : []
                                            }
                                            onChange={(val) => {
                                                // ❌ Prevent clearing if only one store
                                                if (adminStoreIds.length === 1) return;

                                                setFormData(prev => ({
                                                    ...prev,
                                                    storeId: val?.[0]?.value || "",
                                                    storeName: val?.[0]?.label || "",
                                                    categoryId: "",
                                                    categoryName: "",
                                                    subCategoryId: "",
                                                    subCategoryName: ""
                                                }));
                                            }}
                                            loadStores={loadStores}
                                            loggedInRole={role}
                                            assignedStoreIds={adminStoreIds}
                                            isDisabled={adminStoreIds.length === 1}   // 🔥 KEY LINE
                                        />

                                        {errors.storeId && (
                                            <p className="field-error">{errors.storeId}</p>
                                        )}
                                    </div>
                                    <div className="Product-form-group">
                                        <label className="input-label">Variant Name</label>
                                        <input
                                            type="text"
                                            placeholder="Enter Variant name"
                                            className="Product-input"
                                            value={formData.variantName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, variantName: e.target.value }))
                                            }
                                        />
                                        {errors.variantName && <p className="field-error">{errors.variantName}</p>}
                                    </div>
                                </div>
                                <div className="Product-form-row">
                                    <div className="Product-form-group">
                                        <label className="input-label">UPC Number</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            maxLength={12}
                                            title="UPC must be exactly 12 digits"
                                            value={formData.upc}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits and max 12 characters
                                                if (/^\d{0,12}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, upc: value }));
                                                }
                                            }}
                                            onBlur={() => {
                                                if (formData.upc && formData.upc.length !== 12) {
                                                    alert("UPC must be exactly 12 digits");
                                                }
                                            }}
                                        />
                                        {errors.upc && <p className="field-error">{errors.upc}</p>}
                                    </div>
                                    <div className="Product-form-group">
                                        <label className="input-label">Unit Type</label>
                                        <select
                                            id="unitType"
                                            className="category-input"
                                            required
                                            value={formData.unitType}
                                            onChange={(e) => {
                                                const selectedUnitType = e.target.value;
                                                setFormData((prev) => ({ ...prev, unitType: selectedUnitType, unitName: '' }))
                                            }}
                                        >
                                            <option value='' >Select Unit Type</option>
                                            <option value='weight'>Weight</option>
                                            <option value='volume'>Volume</option>
                                            <option value='unit'>Unit</option>
                                        </select>
                                        {errors.unitType && <p className="field-error">{errors.unitType}</p>}
                                    </div>
                                    <div className="Product-form-group">
                                        <label className="input-label">Unit Name</label>
                                        <select
                                            id="unitValue"
                                            className="category-input"
                                            disabled={!formData.unitType} // Only enabled if unitType is selected
                                            onChange={(e) =>
                                                setFormData((prev) => ({ ...prev, unitName: e.target.value }))
                                            }
                                        >
                                            <option value="">Select UnitName</option>
                                            {(unitOptions[formData.unitType] || []).map((unit) => (
                                                <option key={unit} value={unit}>
                                                    {unit}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.unitName && <p className="field-error">{errors.unitName}</p>}
                                    </div>

                                    <div className="Product-form-group">
                                        <label className="input-label">Unit Value</label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            required
                                            maxLength={3}
                                            disabled={!formData.unitName}
                                            value={formData.unitValue}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                // Allow only digits up to 3 characters
                                                if (/^\d{0,3}$/.test(value)) {
                                                    setFormData((prev) => ({ ...prev, unitValue: value }));
                                                }
                                            }} />
                                        {errors.unitValue && <p className="field-error">{errors.unitValue}</p>}
                                    </div>

                                </div>
                                <div className="Product-form-row">
                                    <div className="Product-form-group">
                                        <label htmlFor="hsnCode" className="input-label">
                                            HSN Code
                                        </label>
                                        <input
                                            type="text"
                                            className="category-input"
                                            required
                                            value={formData.hsnCode}
                                            onChange={(e) => setFormData((prev) => ({ ...prev, hsnCode: e.target.value }))}
                                        />
                                    </div>
                                    <div className="Product-form-group">
                                        <label htmlFor="categoryId" className="input-label">
                                            Category Name
                                        </label>

                                        <CategorySelect
                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                                            onChange={(val) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: val?.value || "",
                                                    categoryName: val?.label || "",
                                                    subCategoryId: "",
                                                    subCategoryName: ""
                                                }));
                                            }}
                                            loadCategories={loadCategories}
                                            isMulti={false}
                                            onAddCategory={() => setIsAddCategory(true)}
                                            loggedInRole={role}
                                        />

                                        {errors.categoryId && <p className="field-error">{errors.categoryId}</p>}
                                    </div>

                                    <div className="Product-form-group">
                                        <label htmlFor="subCategoryId" className="input-label">
                                            Sub Category Name
                                        </label>

                                        <SubCategorySelect
                                            key={`${formData.storeId}-${formData.categoryId}-${subCategoryRefreshKey}`}
                                            value={formData.subCategoryId ? { value: formData.subCategoryId, label: formData.subCategoryName || "Selected SubCategory" } : null}
                                            onChange={(val) => {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    subCategoryId: val?.value || "",
                                                    subCategoryName: val?.label || ""
                                                }));
                                            }}
                                            loadSubCategories={loadSubCategories}
                                            isMulti={false}
                                            onAddSubCategory={() => setIsAddSubCategory(true)}
                                            loggedInRole={role}
                                        />

                                        {errors.subCategoryId && <p className="field-error">{errors.subCategoryId}</p>}
                                    </div>

                                    <div className="Product-form-group">
                                        <label htmlFor="ideal_for" className="input-label">
                                            Ideal For
                                        </label>
                                        <select
                                            id="ideal_for"
                                            className="category-input"
                                            required
                                            disabled={!formData.subCategoryId}
                                            value={formData.ideal_for}
                                            onChange={(e) => {
                                                setFormData((prev) => ({ ...prev, ideal_for: e.target.value }))
                                            }}
                                        >
                                            <option value='' >Select Ideal For</option>
                                            <option value='men'>Men</option>
                                            <option value='women'>Women</option>
                                            <option value='unisex'>Unisex</option>
                                        </select>
                                        {errors.ideal_for && <p className="field-error">{errors.ideal_for}</p>}
                                    </div>
                                    <div className="Product-form-group">
                                        <label className="input-label">GST (%)</label>
                                        <select
                                            className="category-input"
                                            disabled={!isGSTVerified}
                                            value={String(formData.gstPercentage ?? "")}
                                            onChange={(e) => {
                                                const gstPercentage = Number(e.target.value);
                                                const sellingPrice = Number(formData.sellingPrice || 0);
                                                const gstAmount = calculateGSTAmount(sellingPrice, gstPercentage);

                                                setFormData(prev => ({
                                                    ...prev,
                                                    gstPercentage,
                                                    gstAmount
                                                }));
                                            }}
                                        >
                                            <option value="">Select GST</option>
                                            <option value="0">0%</option>
                                            <option value="5">5%</option>
                                            <option value="12">12%</option>
                                            <option value="18">18%</option>
                                        </select>


                                        {errors.gstPercentage && <p className="field-error">{errors.gstPercentage}</p>}
                                    </div>
                                </div>

                                <div className="Product-form-row">


                                    <div className="Product-form-group" style={{ gridColumn: 'span 2' }}>
                                        <label htmlFor="ProductImage" className="input-label">
                                            Product Image (Max 1MB, JPEG/JPG/PNG only)
                                        </label>
                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="addUploadMethod"
                                                    checked={uploadMethod === "Normal"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Normal");
                                                        setPreviewUrl(productImage ? URL.createObjectURL(productImage) : null);
                                                    }}
                                                />
                                                Normal Upload
                                            </label>
                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                <input
                                                    type="radio"
                                                    name="addUploadMethod"
                                                    checked={uploadMethod === "Stock"}
                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                    onChange={() => {
                                                        setUploadMethod("Stock");
                                                        if (selectedStockImage) {
                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                        } else {
                                                            setPreviewUrl(null);
                                                        }
                                                    }}
                                                />
                                                Stock Image
                                            </label>
                                        </div>

                                        {uploadMethod === "Normal" ? (
                                            <div className="file-input-wrapper">
                                                <input
                                                    type="file"
                                                    accept=".jpeg,.jpg,.png"
                                                    id="ProductImage"
                                                    className="Product-input"
                                                    onChange={(e) => {
                                                        const file = e.target.files[0];
                                                        if (file) {
                                                            const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                            const allowedExtensions = ["jpg", "jpeg", "png"];
                                                            const fileExtension = file.name.split('.').pop().toLowerCase();
                                                            const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                            if (!isValidType) {
                                                                setErrors(prev => ({ ...prev, productImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                setProductImage(null);
                                                                setPreviewUrl(null);
                                                                if (e.target) e.target.value = "";
                                                            } else if (file.size > 1024 * 1024) {
                                                                setErrors(prev => ({ ...prev, productImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                setProductImage(null);
                                                                setPreviewUrl(null);
                                                                if (e.target) e.target.value = "";
                                                            } else {
                                                                setProductImage(file);
                                                                setPreviewUrl(URL.createObjectURL(file));
                                                                setErrors(prev => ({ ...prev, productImage: null }));
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div className="stock-picker-trigger">
                                                <button
                                                    type="button"
                                                    className="select-stock-btn"
                                                    onClick={() => setShowStockPicker(true)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px 12px',
                                                        background: '#fff',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '6px',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        textAlign: 'left',
                                                        justifyContent: 'flex-start',
                                                        gap: '10px',
                                                        fontSize: '14px',
                                                        color: selectedStockImage ? '#333' : '#888'
                                                    }}
                                                >
                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                </button>
                                            </div>
                                        )}
                                        {errors.productImage && <p className="field-error">{errors.productImage}</p>}

                                        {previewUrl && (
                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                <div style={{ position: 'relative' }}>
                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                    <div
                                                        style={{
                                                            position: 'absolute',
                                                            top: '-8px',
                                                            right: '-8px',
                                                            background: '#ef4444',
                                                            color: 'white',
                                                            borderRadius: '50%',
                                                            width: '20px',
                                                            height: '20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                            zIndex: 5
                                                        }}
                                                        onClick={handleRemoveImage}
                                                        title="Remove image"
                                                    >
                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                    </div>
                                                </div>
                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                    <div style={{ paddingTop: '4px' }}>
                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="Product-buttons">
                                    <button className="add-Product-button" type="submit" onClick={handleAddProduct}>
                                        Add Product
                                    </button>
                                    <button className="cancel-Product-button" onClick={() => navigate('/products')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <Typography variant="h6" gutterBottom sx={{ color: '#191c24' }}>
                                Products
                            </Typography>
                            <div className="product-widgets">
                                <div className="product-widgets-left">
                                    <div className="search-input-wrapper">
                                        <input
                                            type="text"
                                            placeholder="Search products..."
                                            className="product-search-input"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <Icon icon="mdi:magnify" className="search-icon" />
                                    </div>
                                    {["SuperAdmin", "SelfAdmin", "Manager", "Accountant"].includes(role) && (
                                        <StoreSingleAllStoresSelect
                                            value={store}
                                            onChange={(val) => setStore(val)}
                                        />
                                    )}
                                </div>
                                <div className="add-product-buttons desktop-only">
                                    <button className="add-btn-product" onClick={handleExportExcelProductData}>
                                        Export
                                    </button>
                                    <button
                                        className="add-btn-product"
                                        onClick={() => fileInputRef.current.click()}
                                    >
                                        Import
                                    </button>
                                    <button className="add-btn-product" onClick={() => navigate('/products/add')}>+ Add Product</button>
                                    <button className="add-btn-product" onClick={handleExportExcel}>Download Sample Template</button>
                                </div>

                                <div className="add-product-buttons mobile-only">
                                    <button className="add-btn-product" onClick={() => navigate('/products/add')}>+ Add Product</button>

                                    <button
                                        className="add-btn-product dropdown-trigger"
                                        onClick={handleActionClick}
                                        style={{
                                            background: '#f8fafc',
                                            color: '#3C0008',
                                            border: '1px solid #3C0008',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '4px'
                                        }}
                                    >
                                        <Icon icon="mdi:tune" width="18" /> Actions
                                    </button>

                                    <Menu
                                        anchorEl={actionAnchorEl}
                                        open={isActionMenuOpen}
                                        onClose={handleActionClose}
                                        PaperProps={{
                                            sx: {
                                                borderRadius: '12px',
                                                mt: 1,
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                                                border: '1px solid #e2e8f0',
                                                '& .MuiMenuItem-root': {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '10px'
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcelProductData();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:export" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Export
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                fileInputRef.current.click();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:import" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Import
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                handleActionClose();
                                                handleExportExcel();
                                            }}
                                            sx={{ fontSize: '14px', fontWeight: 500, color: '#334155', px: 2, py: 1.2 }}
                                        >
                                            <Icon icon="mdi:download" style={{ fontSize: '18px', color: '#64748b' }} />
                                            Download Sample Template
                                        </MenuItem>
                                    </Menu>
                                </div>
                                <input
                                    type="file"
                                    accept=".xlsx, .xls"
                                    style={{ display: "none" }}
                                    ref={fileInputRef}
                                    onChange={handleBulkUploadClick}
                                />
                            </div>
                            <Box
                                component={Paper}
                            >
                                <TableContainer component={Paper} sx={{
                                    maxHeight: 450,
                                    overflowY: "auto",
                                    '&::-webkit-scrollbar': { display: 'none' },
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                    boxShadow: 'none',
                                    backgroundColor: '#ffffffff',
                                }}>
                                    <Table className="custom-product-table">
                                        <TableHead className="custom-product-head">
                                            <TableRow>
                                                {headings.map((heading, index) => {
                                                    const isProductTitle = heading === "Name";
                                                    const isLocation = heading === "Location";
                                                    const isGST = heading === "GST (%)";
                                                    const isPrice = heading === "Price";
                                                    const isMRP = heading === "Maximum Retail Price";
                                                    const sortKey = isProductTitle
                                                        ? "title"
                                                        : isLocation
                                                            ? "storeId"
                                                            : isGST
                                                                ? "gstPercentage"
                                                                : isPrice
                                                                    ? "sellingPrice"
                                                                    : isMRP
                                                                        ? "sellingPrice"
                                                                        : null

                                                    return (
                                                        <TableCell
                                                            key={index}
                                                            sx={{
                                                                border: "none",
                                                                padding: "12px 16px",
                                                                textAlign: "center",
                                                                position: "sticky",
                                                                top: 0,
                                                                zIndex: 0,
                                                                backgroundColor: "#3C0008",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    gap: "4px",
                                                                    color: "#ffffff",
                                                                    fontSize: "14px",
                                                                    fontWeight: 600,
                                                                }}
                                                            >
                                                                {heading}

                                                                {sortKey && (
                                                                    <span
                                                                        onClick={() => handleSort(sortKey)}
                                                                        style={{
                                                                            fontSize: "10px",
                                                                            color: "#ffffffff",
                                                                            cursor: "pointer",
                                                                            marginLeft: "4px",
                                                                            userSelect: "none",
                                                                        }}
                                                                    >
                                                                        {sortField === sortKey
                                                                            ? sortOrder === 1
                                                                                ? "▲"
                                                                                : "▼"
                                                                            : "▲▼"}
                                                                    </span>
                                                                )}
                                                            </Typography>
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {products.length === 0 ? (
                                                <TableRow>
                                                    <TableCell colSpan={5}>
                                                        <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                            No Products found.
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                products.map((product, index) => (
                                                    <TableRow key={product._id}>
                                                        <TableCell>
                                                            <Typography sx={commonCellStyle}>
                                                                {(currentPage - 1) * (limit === 'all' ? 0 : limit) + index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                                <img
                                                                    src={product?.productImageObject?.uri ? `${process.env.REACT_APP_API_URL}${product.productImageObject.uri}` : "/assets/placeholder.png"}
                                                                    alt={product.title || product.name}
                                                                    onError={(e) => { e.target.onerror = null; e.target.src = "/assets/placeholder.png"; }}
                                                                    style={{ width: '50px', height: '50px', borderRadius: '8px', objectFit: 'cover' }}
                                                                />
                                                            </Box>
                                                        </TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{product.title}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{product.store?.[0]?.storeName}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>{product.gstPercentage !== undefined && product.gstPercentage !== null ? `${product.gstPercentage}%` : '-'}</Typography></TableCell>
                                                        <TableCell><Typography sx={commonCellStyle}>₹{product.sellingPrice}</Typography></TableCell>
                                                        <TableCell>
                                                            <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                                <Tooltip title="View Product">
                                                                    <Icon icon={plusIcon} width={20} height={20} onClick={() => handleViewProduct(product._id)} style={{ cursor: "pointer" }} />
                                                                </Tooltip>
                                                                <Tooltip title="Edit Product">
                                                                    <Icon
                                                                        icon={editIcon}
                                                                        width={20}
                                                                        height={20}
                                                                        style={{ cursor: "pointer" }}

                                                                        onClick={() => {
                                                                            console.log("Editing Product Data:", product);
                                                                            setFormData({
                                                                                title: product.title || "",

                                                                                // ✅ STORE ID + NAME SEPARATELY
                                                                                categoryId: product.categoryDetails?.categoryId?._id || product.categoryId || "",
                                                                                categoryName: product.categoryDetails?.categoryName || "",

                                                                                subCategoryId: product.subCategoryDetails?.subCategoryId?._id || product.subCategoryId || "",
                                                                                subCategoryName: product.subCategoryDetails?.subCategoryName || "",

                                                                                storeId: product.store?.[0]?._id || product.storeId || "",
                                                                                storeName: product.store?.[0]?.storeName || "",

                                                                                upc: product.upc || "",
                                                                                unitType: product.unitType || "",
                                                                                unitName: product.unitName || "",
                                                                                unitValue: product.unitValue || "",

                                                                                ideal_for: product.ideal_for || "",

                                                                                sellingPrice: product.sellingPrice || "",
                                                                                gstPercentage: product.gstPercentage || "",
                                                                                gstAmount: product.gstAmount || "",

                                                                                hsnCode: product.hsnCode || "",
                                                                                productImageObject: product?.productImageObject || "",
                                                                            });

                                                                            setPreviewUrl(
                                                                                product?.productImageObject?.uri
                                                                                    ? `${process.env.REACT_APP_API_URL}${product.productImageObject.uri}`
                                                                                    : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                            );
                                                                            if (product.imageSource === "Stock") {
                                                                                setUploadMethod("Stock");
                                                                                setSelectedStockImage(product.productImageObject);
                                                                                const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                                const uri = product.productImageObject?.uri || product.productImageObject?.fileObject?.uri || "";
                                                                                setPreviewUrl(uri ? `${baseUrl}/${uri.replace(/^\/+/, "")}` : null);
                                                                            } else {
                                                                                setUploadMethod("Normal");
                                                                                setSelectedStockImage(null);
                                                                                setPreviewUrl(
                                                                                    product?.productImageObject?.uri
                                                                                        ? `${process.env.REACT_APP_API_URL || ""}${product.productImageObject.uri}`
                                                                                        : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                                                                                );
                                                                            }

                                                                            setProductImage(null);
                                                                            setEditProductId(product._id);
                                                                            setIsPopupMode(true);
                                                                            setIsEditMode(true);
                                                                            setLoaderText("Updating Product...");
                                                                        }}
                                                                    />
                                                                </Tooltip>

                                                                {role !== "SelfAdmin" && (
                                                                    <Tooltip title="Delete Product">
                                                                        <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000', cursor: "pointer" }}
                                                                            onClick={() => handleOpen(product._id)}
                                                                        />
                                                                    </Tooltip>
                                                                )}
                                                            </Box>

                                                        </TableCell>
                                                    </TableRow>

                                                ))
                                            )}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <div className="product-bottom">
                                    <div className="product-section show-entries">
                                        <span className="text-label">Show</span>
                                        <select className="entries-select" value={limit}
                                            onChange={handleItemsPerPageChange}
                                        >
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="all">All</option>
                                        </select>
                                        <span className="text-label">Entries</span>
                                    </div>
                                    <div className="product-section showing-range">
                                        {
                                            limit === 'all'
                                                ? `Showing all ${totalCount} entries`
                                                : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                        }
                                    </div>
                                    <div className="product-section spacer"></div>
                                    <div className="product-section pagination-buttons">
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("first")}
                                        >
                                            <Icon icon="mdi:chevron-double-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange("prev")}
                                        >
                                            <Icon icon="mdi:chevron-left" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages || totalPages === 0}
                                            onClick={() => handlePageChange("next")}
                                        >
                                            <Icon icon="mdi:chevron-right" />
                                        </button>
                                        <button
                                            className="pagination-btn"
                                            disabled={currentPage === totalPages || totalPages === 0}
                                            onClick={() => handlePageChange("last")}
                                        >
                                            <Icon icon="mdi:chevron-double-right" />
                                        </button>
                                    </div>
                                </div>
                            </Box>
                            {isPopupMode && (
                                <div className="popup-overlay">
                                    <div className="popup-wrapper">
                                        <Icon
                                            icon={closeIcon}
                                            className="popup-close-icon-outside"
                                            onClick={() => {
                                                setIsPopupMode(false);
                                                setIsEditMode(false);
                                                setPreviewUrl(null);
                                                setLoaderText("");
                                            }}
                                        />

                                        <div className="popup-form">
                                            <Typography variant="h6" textAlign={"center"} gutterBottom sx={{ color: '#191c24', mb: 4 }}>
                                                {isEditMode ? "Edit Product" : "Add Product"}
                                            </Typography>
                                            <form className="popup-form-body" onSubmit={handleUpdateProduct}>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="title">Title</label>
                                                        <input
                                                            type="text"
                                                            id="title"
                                                            value={formData.title}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    title: e.target.value,
                                                                }))
                                                            }
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label className="input-label">Store Name</label>
                                                        <StoreMultiSelect
                                                            value={
                                                                formData.storeId
                                                                    ? (Array.isArray(formData.storeId)
                                                                        ? formData.storeId.map((id, i) => ({
                                                                            value: id,
                                                                            label: Array.isArray(formData.storeName) ? formData.storeName[i] : formData.storeName
                                                                        }))
                                                                        : [{ value: formData.storeId, label: formData.storeName }]
                                                                    )
                                                                    : []
                                                            }
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    storeId: val.map(v => v.value),
                                                                    storeName: val.map(v => v.label),
                                                                    categoryId: "",
                                                                    categoryName: "",
                                                                    subCategoryId: "",
                                                                    subCategoryName: ""
                                                                }));
                                                            }}
                                                            loadStores={loadStores}
                                                            loggedInRole={role}
                                                            assignedStoreIds={adminStoreIds}
                                                            onAddStore={() => setIsAddStore(true)}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="upcNumber">UPC Number</label>
                                                        <input
                                                            type="text"
                                                            id="upcNumber"
                                                            maxLength={12}
                                                            title="UPC must be exactly 12 digits"
                                                            value={formData.upc}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits and max 12 characters
                                                                if (/^\d{0,12}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, upc: value }));
                                                                }
                                                            }}
                                                            onBlur={() => {
                                                                if (formData.upc && formData.upc.length !== 12) {
                                                                    alert("UPC must be exactly 12 digits");
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="unitType">UnitType</label>
                                                        <select
                                                            id="unitType"
                                                            className="category-input"
                                                            value={formData.unitType}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, unitType: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select UnitType</option>
                                                            <option value='unit'>Unit</option>
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="unitName">UnitName</label>
                                                        <select
                                                            id="unitName"
                                                            className="category-input"
                                                            value={formData.unitName}
                                                            onChange={(e) =>
                                                                setFormData((prev) => ({ ...prev, unitName: e.target.value }))
                                                            }
                                                        >
                                                            <option value="">Select UnitName</option>
                                                            {(unitOptions[formData.unitType] || []).map((unit) => (
                                                                <option key={unit} value={unit}>
                                                                    {unit}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="unitValue">UnitValue</label>
                                                        <input
                                                            type="text"
                                                            className="category-input"
                                                            maxLength={3}
                                                            value={formData.unitValue}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                // Allow only digits up to 3 characters
                                                                if (/^\d{0,3}$/.test(value)) {
                                                                    setFormData((prev) => ({ ...prev, unitValue: value }));
                                                                }
                                                            }} />
                                                    </div>
                                                </div>
                                                <div className="form-group-row">
                                                    <div className="form-group">
                                                        <label htmlFor="categoryname" className="input-label">
                                                            Category Name
                                                        </label>
                                                        <CategorySelect
                                                            key={`${formData.storeId}-${categoryRefreshKey}`}
                                                            value={formData.categoryId ? { value: formData.categoryId, label: formData.categoryName || "Selected Category" } : null}
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    categoryId: val?.value || "",
                                                                    categoryName: val?.label || ""
                                                                }));
                                                            }}
                                                            loadCategories={loadCategories}
                                                            isMulti={false}
                                                            loggedInRole={role}
                                                            onAddCategory={() => setIsAddCategory(true)}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="subCategoryName" className="input-label">
                                                            Sub Category Name
                                                        </label>
                                                        <SubCategorySelect
                                                            key={`${formData.storeId}-${formData.categoryId}-${subCategoryRefreshKey}`}
                                                            value={formData.subCategoryId ? { value: formData.subCategoryId, label: formData.subCategoryName || "Selected SubCategory" } : null}
                                                            onChange={(val) => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    subCategoryId: val?.value || "",
                                                                    subCategoryName: val?.label || ""
                                                                }));
                                                            }}
                                                            loadSubCategories={loadSubCategories}
                                                            isMulti={false}
                                                            onAddSubCategory={() => setIsAddSubCategory(true)}
                                                            loggedInRole={role}
                                                        />
                                                    </div>
                                                    <div className="form-group">
                                                        <label htmlFor="ideal_for" className="input-label">
                                                            Ideal For
                                                        </label>
                                                        <select
                                                            id="ideal_for"
                                                            className="category-input"
                                                            required
                                                            disabled={!formData.subCategoryId}
                                                            value={formData.ideal_for}
                                                            onChange={(e) => {
                                                                setFormData((prev) => ({ ...prev, ideal_for: e.target.value }))
                                                            }}
                                                        >
                                                            <option value='' >Select Ideal For</option>
                                                            <option value='men'>Men</option>
                                                            <option value='women'>Women</option>
                                                            <option value='unisex'>Unisex</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="Product-form-row">
                                                    <div className="Product-form-group">
                                                        <label className="input-label">GST (%)</label>
                                                        <select
                                                            className="category-input"
                                                            value={String(formData.gstPercentage ?? "")}
                                                            onChange={(e) => {
                                                                const gstPercentage = Number(e.target.value);
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    gstPercentage
                                                                }));
                                                            }}
                                                        >
                                                            <option value="">Select GST</option>
                                                            <option value="0">0%</option>
                                                            <option value="5">5%</option>
                                                            <option value="12">12%</option>
                                                            <option value="18">18%</option>
                                                        </select>
                                                        {errors.gstPercentage && <p className="field-error">{errors.gstPercentage}</p>}
                                                    </div>
                                                </div>

                                                <div className="Product-form-row">
                                                    <div className="Product-form-group" style={{ gridColumn: 'span 2' }}>
                                                        <label htmlFor="editProductImage" className="input-label">Product Image (Max 1MB, JPEG/JPG/PNG only)</label>
                                                        <div className="upload-options" style={{ display: 'flex', gap: '20px', marginBottom: '12px' }}>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="editUploadMethod"
                                                                    checked={uploadMethod === "Normal"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Normal");
                                                                        if (productImage) {
                                                                            setPreviewUrl(URL.createObjectURL(productImage));
                                                                        } else {
                                                                            setPreviewUrl(formData.productImageObject?.uri ? `${process.env.REACT_APP_API_URL}${formData.productImageObject.uri}` : null);
                                                                        }
                                                                    }}
                                                                />
                                                                Normal Upload
                                                            </label>
                                                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: '500', color: '#525252' }}>
                                                                <input
                                                                    type="radio"
                                                                    name="editUploadMethod"
                                                                    checked={uploadMethod === "Stock"}
                                                                    style={{ accentColor: 'linear-gradient(90deg, #181B23 0%, #1C202B 35%, #1A1E28 65%, #161A22 100%)' }}
                                                                    onChange={() => {
                                                                        setUploadMethod("Stock");
                                                                        if (selectedStockImage) {
                                                                            const baseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");
                                                                            const uri = selectedStockImage.uri || selectedStockImage.fileObject?.uri || "";
                                                                            setPreviewUrl(`${baseUrl}/${uri.replace(/^\/+/, "")}`);
                                                                        } else {
                                                                            setPreviewUrl(null);
                                                                        }
                                                                    }}
                                                                />
                                                                Stock Image
                                                            </label>
                                                        </div>

                                                        {uploadMethod === "Normal" ? (
                                                            <input
                                                                type="file"
                                                                id="editProductImage"
                                                                accept=".jpeg,.jpg,.png"
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) {
                                                                        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                                                                        const allowedExtensions = ["jpg", "jpeg", "png"];
                                                                        const fileExtension = file.name.split('.').pop().toLowerCase();
                                                                        const isValidType = allowedTypes.includes(file.type) || allowedExtensions.includes(fileExtension);

                                                                        if (!isValidType) {
                                                                            setErrors(prev => ({ ...prev, productImage: "Only JPEG, JPG, and PNG images are allowed." }));
                                                                            toast.error("Only JPEG, JPG, and PNG images are allowed.");
                                                                            setProductImage(null);
                                                                            setPreviewUrl(formData.productImageObject?.uri ? `${process.env.REACT_APP_API_URL}${formData.productImageObject.uri}` : null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else if (file.size > 1024 * 1024) {
                                                                            setErrors(prev => ({ ...prev, productImage: "Image size exceeds 1MB. Please select an image smaller than 1MB." }));
                                                                            toast.error("Image size exceeds 1MB. Please select an image smaller than 1MB.");
                                                                            setProductImage(null);
                                                                            setPreviewUrl(formData.productImageObject?.uri ? `${process.env.REACT_APP_API_URL}${formData.productImageObject.uri}` : null);
                                                                            if (e.target) e.target.value = "";
                                                                        } else {
                                                                            setProductImage(file);
                                                                            setPreviewUrl(URL.createObjectURL(file));
                                                                            setErrors(prev => ({ ...prev, productImage: null }));
                                                                        }
                                                                    }
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className="stock-picker-trigger">
                                                                <button
                                                                    type="button"
                                                                    className="select-stock-btn"
                                                                    onClick={() => setShowStockPicker(true)}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '8px 12px',
                                                                        background: '#fff',
                                                                        border: '1px solid #ccc',
                                                                        borderRadius: '6px',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        textAlign: 'left',
                                                                        justifyContent: 'flex-start',
                                                                        gap: '10px',
                                                                        fontSize: '14px',
                                                                        color: selectedStockImage ? '#333' : '#888'
                                                                    }}
                                                                >
                                                                    <Icon icon="mdi:image-search" style={{ fontSize: '18px', color: '#64748b' }} />
                                                                    {selectedStockImage ? `Selected: ${selectedStockImage.name || 'Stock Image'}` : "Click to select a stock image..."}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {errors.productImage && <p className="field-error">{errors.productImage}</p>}

                                                        {previewUrl && (
                                                            <div className="image-preview" style={{ marginTop: '12px', display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
                                                                <div style={{ position: 'relative' }}>
                                                                    <img src={previewUrl} alt="Preview" style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />
                                                                    <div
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: '-8px',
                                                                            right: '-8px',
                                                                            background: '#ef4444',
                                                                            color: 'white',
                                                                            borderRadius: '50%',
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'center',
                                                                            cursor: 'pointer',
                                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                            zIndex: 5
                                                                        }}
                                                                        onClick={handleRemoveImage}
                                                                        title="Remove image"
                                                                    >
                                                                        <Icon icon="mdi:close" style={{ fontSize: '14px' }} />
                                                                    </div>
                                                                </div>
                                                                {uploadMethod === "Stock" && selectedStockImage && (
                                                                    <div style={{ paddingTop: '4px' }}>
                                                                        <p style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', margin: '0' }}>Stock Image Selected</p>
                                                                        <p style={{ fontSize: '11px', color: '#64748b', margin: '2px 0 0' }}>{selectedStockImage.name}</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-actions">
                                                    <button type="submit" className="add-Product-button">
                                                        {isEditMode ? "Update Product" : "Add Product"}
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="cancel-Product-button"
                                                        onClick={() => setIsPopupMode(false)}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                            >
                                <Box
                                    sx={{
                                        position: "absolute",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        width: 380,
                                        background: "linear-gradient(135deg, #ffffff, #faf5f6)",
                                        borderRadius: "20px",
                                        boxShadow: "0 25px 70px rgba(0,0,0,0.35)",
                                        p: 4,
                                        outline: "none",
                                        textAlign: "center",
                                        overflow: "hidden"
                                    }}
                                >
                                    {/* ✅ TOP ICON BADGE */}
                                    <Box
                                        sx={{
                                            width: 74,
                                            height: 74,
                                            borderRadius: "50%",
                                            background: "#3C0008",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            margin: "0 auto 16px auto",
                                            color: "#fff",
                                            fontSize: 30,

                                            boxShadow: "0 12px 28px rgba(26,30,39,0.55)",
                                            animation: "deletePulse 1.6s infinite ease-in-out",

                                            "@keyframes deletePulse": {
                                                "0%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0.7)",
                                                },
                                                "70%": {
                                                    transform: "scale(1.1)",
                                                    boxShadow: "0 0 0 18px rgba(26,30,39,0)",
                                                },
                                                "100%": {
                                                    transform: "scale(1)",
                                                    boxShadow: "0 0 0 0 rgba(26,30,39,0)",
                                                },
                                            },
                                        }}
                                    >
                                        🗑️
                                    </Box>


                                    {/* ✅ TITLE */}
                                    <Typography
                                        id="modal-modal-title"
                                        variant="h6"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#2b2b2b",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Confirm Delete
                                    </Typography>

                                    {/* ✅ DESCRIPTION */}
                                    <Typography
                                        id="modal-modal-description"
                                        sx={{
                                            mt: 1.2,
                                            fontSize: 14,
                                            color: "#666",
                                            lineHeight: 1.6
                                        }}
                                    >
                                        Are you sure you want to delete this product?
                                    </Typography>

                                    {/* ✅ BUTTON GROUP */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            gap: 2.5,
                                            mt: 3.5
                                        }}
                                    >
                                        {/* ✅ DELETE BUTTON */}
                                        <button
                                            onClick={handleDeleteProduct}
                                            className="add-Product-button"
                                        >
                                            Yes, Delete
                                        </button>

                                        {/* ✅ CANCEL BUTTON */}
                                        <button
                                            onClick={handleClose}
                                            className="cancel-Product-button"
                                        >
                                            Cancel
                                        </button>
                                    </Box>
                                </Box>
                            </Modal>
                            {openViewPopup && (
                                <ViewProductPopup
                                    data={viewProductData}
                                    onClose={() => setOpenViewPopup(false)}
                                />
                            )}
                        </>
                    )
                    }
                    {isAddStore && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddStore(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddStoreForm
                                        onSuccess={() => {
                                            setIsAddStore(false);
                                        }}
                                        onCancel={() => setIsAddStore(false)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isAddCategory && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddCategory(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddCategoryForm
                                        onSuccess={(newCategory) => {
                                            setIsAddCategory(false);
                                            setCategoryRefreshKey(prev => prev + 1);
                                            if (newCategory) {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    categoryId: newCategory._id,
                                                    categoryName: newCategory.categoryName,
                                                    subCategoryId: "",
                                                    subCategoryName: ""
                                                }));
                                            }
                                        }}
                                        onCancel={() => setIsAddCategory(false)}
                                        initialStoreId={formData.storeId}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {isAddSubCategory && (
                        <div className="popup-overlay">
                            <div className="popup-wrapper" style={{ maxWidth: '900px', width: '95%' }}>
                                <Icon
                                    icon={closeIcon}
                                    className="popup-close-icon-outside"
                                    onClick={() => setIsAddSubCategory(false)}
                                />
                                <div className="popup-form" style={{ maxHeight: '85vh', overflowY: 'auto', padding: '20px' }}>
                                    <AddSubCategoryForm
                                        onSuccess={(newSubCategory) => {
                                            setIsAddSubCategory(false);
                                            setSubCategoryRefreshKey(prev => prev + 1);
                                            if (newSubCategory) {
                                                setFormData(prev => ({
                                                    ...prev,
                                                    subCategoryId: newSubCategory._id,
                                                    subCategoryName: newSubCategory.subCategoryName || newSubCategory.name
                                                }));
                                            }
                                        }}
                                        onCancel={() => setIsAddSubCategory(false)}
                                        initialStoreId={formData.storeId}
                                        initialCategoryId={formData.categoryId}
                                        categoryName={formData.categoryName}
                                        hideAddCategory={true}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    {showStockPicker && (
                        <StockImagePicker
                            onSelect={handleStockSelect}
                            onCancel={() => setShowStockPicker(false)}
                        />
                    )}
                </main >
                <Footer />
            </div >
        </div >
    );
};

export default ProductPage;